import React from 'react';

/**
 * Isolates the Mini Chat Dock from the rest of the app. It's mounted at the
 * app root (see App.js) alongside every other page, so an uncaught error
 * inside it (a render crash, a bug in a message handler, etc.) must not take
 * down the whole app's interactivity — without this boundary, React unmounts
 * the entire tree above the nearest boundary, which was the app root itself,
 * leaving pages unresponsive until a manual reload.
 */
class MiniChatErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('Mini Chat Dock crashed — isolated, rest of the app keeps working:', error, info);
  }

  render() {
    if (this.state.hasError) return null;
    return this.props.children;
  }
}

export default MiniChatErrorBoundary;
